export default __webpack_public_path__ + "static/media/joseph-spadavecchia.28853c58.png";